<template>
	<div class="footer-wrapper">
		<div class="container">
			<div class="row">
				<div class="col-lg-4 col-md-6 mb-3">
					<div class="d-flex align-items-start flex-column">
						<div class="mb-auto">
							<img class="ostock-icon" width="200px" :src="appLogo" alt="icon">
							<div class="brand-description">
								Ostock merupakan platform penyedia produk untuk berjualan tanpa modal, tanpa harus nyetok, tanpa packing dan tanpa ribet.
							</div>
						</div>
						<div class="brand-copyright mt-3">
							PT. Ostock Profitama Indonesia
						</div>
						<div class="brand-copyright">
							© {{ new Date().getFullYear() }}. Ostock.id
						</div>
					</div>
				</div>
				<div class="col-lg-2 col-md-6 mb-3">
					<div class="row">
						<!-- <div class="col-md-6">
							<div class="heading-label mb-2">Company</div>
							<router-link to="#" class="text-secondary">
								<div>About</div>
							</router-link>
							<div>Blog</div>
							<div>Carrier</div>
						</div> -->
						<div class="col-md-12">
							<div class="heading-label mb-2">Support</div>
							<!-- <router-link to="/page/contact" class="text-secondary">
								<div>Contact</div>
							</router-link> -->
							<a href="https://help.ostock.id" class="text-secondary" target="_blank">Help Center</a>
							<router-link to="/page/privacy" class="text-secondary">
								<div>Privacy &#38; Policy</div>
							</router-link>
							<router-link to="/page/tnc" class="text-secondary">
								<div>Terms &#38; Conditions Seller</div>
							</router-link>
							<router-link to="/register/supplier" class="text-secondary">
								<div>Register Supplier</div>
							</router-link>
						</div>
					</div>
				</div>
				<!-- <div class="col-lg-3 col-md-6 mb-3">
					<div class="heading-label mb-2">Get the latest news from us</div>
					<div class="input-group mb-3 subscribe">
						<input type="text" class="form-control email" v-model="email" placeholder="Enter your email address" aria-label="Enter your email address" aria-describedby="button-subscribe">
						<div class="input-group-append">
							<button class="btn btn-primary btn-subscribe" type="button" id="button-subscribe"><span class="bi bi-envelope-plus"></span> Subscribe</button>
						</div>
					</div>
					<div class="social">
						<div class="label">Follow Us On</div>
						<div class="icon-container">
							<div class="social-icon" v-for="(social, index) in socialIcons" :key="index">
								<a :href="social.link" target="_blank"><i :class="social.icon"></i></a>
							</div>
						</div>
					</div>
				</div> -->
				<div class="col-lg-3 col-md-6 mb-3">
					<div class="heading-label mb-2">Contact</div>
					<div>
						Ruko CBD Cibubur Blok GR02 No.1, Cluster Granburry, Jl. Raya Alternatif Cibubur KM 5 <br>
						Kota Bekasi - 17434
					</div>
					<div class="mt-1">
						<b>Email: </b> contact@ostock.id
					</div>
					<div class="mt-1">
						<b>Phone: </b> +62 812-2200-1553
					</div>
					<div class="mt-1">
						<b>Phone Alt: </b> +62 812-2428-1917
					</div>
				</div>
				<div class="col-lg-3 col-md-6">
					<img width="160" src="https://cdn.ostock.id/img/master-card-visa.png" alt="Visa">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { footerSocialIcons } from '@/lib/statics';

export default {
	data() {
		return {
			socialIcons: footerSocialIcons,
			email: '',
			appLogo: process.env.VUE_APP_LOGO,
		};
	},
	methods: {
	},
};
</script>

<style lang="scss" scoped>
	.footer-wrapper {
		background: #fff;
		width: 100%;
		padding: 40px 20px;

		ostock-icon {
			width: 180px;
			height: 35px;
		}
	}

	.brand-description {
		font-weight: 500;
		font-size: 12px;
		line-height: 22px;
		color: #4D4D4D;
		margin-top: 10px;
		// text-align: justify;
	}

	.brand-copyright {
		font-weight: 400;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0.75px;
		color: #4D4D4D;
	}

	.heading-label {
		font-weight: 700;
		font-size: 18px;
		line-height: 28px;
		color: #4D4D4D;
	}

	.subscribe {
		.email {
			border-top-left-radius: 5px !important;
			border-bottom-left-radius: 5px !important;
			border: 1px solid #949494;

			&::placeholder {
				color: #423839;
				opacity: 1; /* Firefox */
			}

			&:-ms-input-placeholder { /* Internet Explorer 10-11 */
				color: #423839;
			}

			&::-ms-input-placeholder { /* Microsoft Edge */
				color: #423839;
			}
		}

		.btn-subscribe {
			border-top-right-radius: 5px !important;
			border-bottom-right-radius: 5px !important;
		}
	}

	.social {
		.label {
			font-weight: 700;
			font-size: 18px;
			line-height: 25px;
		}

		.icon-container {
			margin-top: 10px;
			display: flex;
			justify-content: flex-start;

			.social-icon {
				display: flex;
				justify-content: center;
				align-items: center;
				border: 2px solid #4D4D4D;
				border-radius: 5px;
				width: 34px;
				height: 34px;
				margin-right: 10px;

				a {
					text-decoration: none;
					color: #4D4D4D;
				}
			}
		}

	}
</style>
